module.exports = __webpack_public_path__ + "static/media/002.23af374d.jpg";